// extracted by mini-css-extract-plugin
module.exports = {"description":"SlugInput_description__1jhSW","field":"SlugInput_field__34wMx","editor":"SlugInput_editor__47vzk","group":"SlugInput_group__1GDYA","head":"SlugInput_head__2TZUi"};